/**
 * @generated SignedSource<<1023231feb69a443c613682e93fa0cec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WAKPISettings_widgetTaskSingle$data = {
  readonly activeSectionVersions: ReadonlyArray<{
    readonly id: string;
    readonly section: {
      readonly assignedTeam: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"RoutineSectionListItem_RoutineSectionVersion">;
  }>;
  readonly id: string;
  readonly " $fragmentType": "WAKPISettings_widgetTaskSingle";
};
export type WAKPISettings_widgetTaskSingle$key = {
  readonly " $data"?: WAKPISettings_widgetTaskSingle$data;
  readonly " $fragmentSpreads": FragmentRefs<"WAKPISettings_widgetTaskSingle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WAKPISettings_widgetTaskSingle",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSectionVersion",
      "kind": "LinkedField",
      "name": "activeSectionVersions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "assignedTeam",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoutineSectionListItem_RoutineSectionVersion"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTaskSingle",
  "abstractKey": null
};
})();

(node as any).hash = "ca03f51441380c8e8a790a7375db6df1";

export default node;
